import React, { useContext, useState } from "react";
import "./personalinfo.css";
import ProfileHeader from "../components/ProfileHeader";
import { useNavigate, useOutletContext } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { DocumentHandler, ImageHandler, WCPartnerHandle } from "../../../firebase/FileHandler";
import { ReferralPartnerUpdateAPI } from "../../../api/ReferralPartnerAPI";
import { ProfileContext } from "../../../context/ProfileContext";
import Swal from "sweetalert2";

const PersonalInfo = () => {
  const [isEdit, setIsEdit] = useState(false);
  const { openSidebar } = useOutletContext();
  const { user, setUser } = useContext(ProfileContext);
  const isReferral = user?.type === "referralPartner";
  const isWC = user?.type === "wcPartner";
  const [isSaving, setIsSaving] = useState(false);
const [previewImage, setPreviewImage] = useState(null);

  // console.log(user);
  const navigate = useNavigate();

  const getInitialProfile = () => ({
    firstName: user.firstName,
    lastName: user.lastName,
    fullName: user.fullName,
    mobile: user.mobile,
    email: user.email,
    partnerCode: user.partnerCode,
    type: user.type,
    level: user.level,

    // 👇 WC extra fields
    ...(isWC && {
      dateOfBirth: user.dateOfBirth,
      city: user.city,
      state: user.state,
      pincode: user.pincode,
      FullAddress: user.FullAddress,
    }),
  });

  const getInitialCompliance = () => {
    if (isReferral) {
      return {
        kycStatus: user.compliance?.kycStatus,
        agreementSigned: user.compliance?.agreementSigned,
        agreementDate: user.compliance?.agreementDate,
        aadharURL: user.compliance?.aadharURL,
        panURL: user.compliance?.panURL,
        partnerPhoto: user.compliance?.partnerPhoto,
      };
    }

    // ✅ WC Partner structure
    return {
      panURL: user.panURL,
      aadharFrontURL: user.aadharFrontURL,
      aadharBackURL: user.aadharBackURL,
      partnerPhoto: user.partnerPhoto,
    };
  };

  const [profile, setProfile] = useState(getInitialProfile());
  const [compliance, setCompliance] = useState(getInitialCompliance());
  const [aadharBack, setAadharBack] = useState(user.aadharBackURL);

  const [pan, setPan] = useState(isReferral ? user.compliance?.panURL : user.panURL);
  const [aadhar, setAadhar] = useState(
    isReferral ? user.compliance?.aadharURL : user.aadharFrontURL
  );
  const [photo, setPhoto] = useState(
    isReferral ? user.compliance?.partnerPhoto : user.partnerPhoto
  );

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobile") {
      const numericValue = value.replace(/\D/g, "").slice(0, 10);
      setProfile((prev) => ({
        ...prev,
        mobile: numericValue,
      }));
      return;
     }
    // trim only for first & last name
    const trimmedValue =
      name === "firstName" || name === "lastName"
        ? value.replace(/\s+/g, " ").trimStart()
        : value;

    setProfile((prev) => {
      const updatedProfile = {
        ...prev,
        [name]: trimmedValue,
      };

      // 🔥 auto calculate fullName
      if (name === "firstName" || name === "lastName") {
        const first = name === "firstName" ? trimmedValue : prev.firstName;
        const last = name === "lastName" ? trimmedValue : prev.lastName;

        updatedProfile.fullName = `${first} ${last}`.trim();
      }

      return updatedProfile;
    });
  };

  const handleDocumentUpload = async (document, type) => {
  if (!document) return null;
//  console.log('chala')
  try {
    if (isReferral) {
      if (type === "photo") {
        const res = await ImageHandler(document, profile.firstName, profile.lastName);
        if (res.success) return res.downloadURL;
      } else {
        const res = await DocumentHandler(document, type, profile.firstName, profile.lastName);
        if (res.success) return res.downloadURL;
      }
    } else if (isWC) {
      //  console.log('chala')
      const res = await WCPartnerHandle(document, type, profile.firstName, profile.lastName);
      if (res.success) return res.downloadURL;
    }
  } catch (error) {
    console.error(error);
  }

  return null;
};
  const handleUpdate = async () => {
    if(!user._id) return;
    setIsSaving(true);
    try {
      let updatedCompliance = { ...compliance };
      if (pan instanceof File) {
        const url = await handleDocumentUpload(pan, "pan");
        if (url) updatedCompliance.panURL = url;
      }

      if (aadhar instanceof File) {
        const url = await handleDocumentUpload(aadhar, "aadhar-front");
        if (url) updatedCompliance.aadharFrontURL = url;
      }

      if (aadharBack instanceof File) {
        const url = await handleDocumentUpload(aadharBack, "aadhar-back");
        if (url) updatedCompliance.aadharBackURL = url;
      }

      if (photo instanceof File) {
        const url = await handleDocumentUpload(photo, "photo");
        if (url) updatedCompliance.partnerPhoto = url;
      }
      
      setCompliance(updatedCompliance);

      const payload = isReferral
      ? {
          ...profile,
          compliance: updatedCompliance,
        }
      : {
          ...profile,
          panURL: updatedCompliance.panURL,
          aadharFrontURL: updatedCompliance.aadharFrontURL,
          aadharBackURL: updatedCompliance.aadharBackURL,
          partnerPhoto: updatedCompliance.partnerPhoto,
        };

      console.log(payload);
      const res = await ReferralPartnerUpdateAPI(user._id,payload,isReferral);
      if (res?.success) {
      setUser((prev) =>
        isReferral
          ? {
              ...prev,
              ...profile,
              compliance: updatedCompliance,
            }
          : {
              ...prev,
              ...profile,
              ...updatedCompliance,
            }
      );

        Swal.fire({
          icon: "success",
          title: "Profile Updated",
          text: "Your Profile has been successfully updated!",
        });
      }
      else{
        Swal.fire({
          icon: "error",
          title: "Oops!",
          text: res?.message || "Something went wrong. Please try again.",
          confirmButtonText: "OK",
        });
      }

    } catch (error) {
      Swal.fire({
          icon: "error",
          title: "Oops!",
          text: error?.message || "Something went wrong. Please try again.",
          confirmButtonText: "OK",
        });
    }finally{
      setIsSaving(false)
    }
  };

  const isReadOnlyField = (key) =>
    key === "partnerCode" ||
    key === "type" ||
    key === "level" ||
    key === "fullName";

    const handlePanSelect = (e) => {
      if (e.target.files?.[0]) {
        setPan(e.target.files[0]);
      }
    };
    const handleAadharSelect = (e) => {
      if (e.target.files?.[0]) {
        setAadhar(e.target.files[0]);
      }
    };
    const handlePhotoSelect = (e) => {
      if (e.target.files?.[0]) {
        setPhoto(e.target.files[0]);
      }
    };

    const getFilePreview = (file, url, defaultUrl = null) => {
        if (file instanceof File) return URL.createObjectURL(file);
        if (url) return url;
        return defaultUrl;
      };

  return (
    <div className="rp-personalinfo-page">
      <ProfileHeader onMenuClick={openSidebar} val="Personal Information" />

      <div className="rp-personalinfo-card">
        <div className="rp-personalinfo-header">
          <button
            className="rp-personalinfo-back-btn"
            onClick={() => navigate("/profile")}
          >
            <ArrowLeft size={14} /> Back
          </button>
          <button
            className="rp-personalinfo-edit-btn"
            onClick={() => {
              if (isEdit) {
                // 🔥 CANCEL → reset everything
                setProfile(getInitialProfile());
                setCompliance(getInitialCompliance());
             setPan(isReferral ? user.compliance?.panURL : user.panURL);
              setAadhar(isReferral ? user.compliance?.aadharURL : user.aadharFrontURL);
              setPhoto(isReferral ? user.compliance?.partnerPhoto : user.partnerPhoto);
              setAadharBack(user.aadharBackURL);
                setPreviewImage(null);
              }
              setIsEdit(!isEdit);
            }}
          >
            {isEdit ? "Cancel" : "Edit"}
          </button>
        </div>

        {/* Personal Info */}
        <div className="rp-personalinfo-grid">
          {Object.keys(profile).map((key) => (
            <div className="rp-personalinfo-field" key={key}>
              <label className="rp-personalinfo-label">
                {key.replace(/([A-Z])/g, " $1")}
              </label>
              <input
                className="rp-personalinfo-input"
                type="text"
                name={key}
                value={profile[key]}
                onChange={handleChange}
                disabled={!isEdit || isReadOnlyField(key)}
              />
            </div>
          ))}
          {isReferral && (
            <>
              <div className="rp-personalinfo-field">
                <label className="rp-personalinfo-label">KYC Status</label>
                <input className="rp-personalinfo-input" value={compliance.kycStatus ? "Completed" : "Pending"} disabled />
              </div>

              <div className="rp-personalinfo-field">
                <label className="rp-personalinfo-label">Agreement Signed</label>
                <input className="rp-personalinfo-input" value={compliance.agreementSigned ? "Yes" : "No"} disabled />
              </div>

              <div className="rp-personalinfo-field">
                <label className="rp-personalinfo-label">Agreement Date</label>
                <input className="rp-personalinfo-input" value={compliance.agreementDate} disabled />
              </div>
            </>
          )}
        </div>
        <div className="rp-personalinfo-compliance-row">
<div className="rp-personalinfo-compliance-item">
  <label className="rp-personalinfo-label">
    Aadhar
  </label>

  {(isReferral ? compliance.aadharURL : compliance.aadharFrontURL) || aadhar ? (
    <div className="rp-personalinfo-file-card">
      <img
        src={
          aadhar instanceof File
            ? URL.createObjectURL(aadhar)
            : isReferral
            ? compliance.aadharURL
            : compliance.aadharFrontURL
        }
        className="rp-personalinfo-thumb"
        alt="Aadhar"
      />
      <div className="rp-personalinfo-file-actions">
        <button
          className="rp-personalinfo-view-btn"
          disabled={
            !(aadhar instanceof File || (isReferral ? compliance.aadharURL : compliance.aadharFrontURL))
          }
          onClick={() =>
            setPreviewImage(
              aadhar instanceof File
                ? URL.createObjectURL(aadhar)
                : isReferral
                ? compliance.aadharURL
                : compliance.aadharFrontURL
            )
          }
        >
          View
        </button>
        {isEdit && (
          <label className="rp-personalinfo-change-btn">
            Edit
            <input
              type="file"
              hidden
              onChange={handleAadharSelect}
            />
          </label>
        )}
      </div>
    </div>
  ) : (
    <label className="rp-personalinfo-upload-card">
      <div className="rp-personalinfo-plus">+</div>
      <span>Upload Aadhar</span>
      <input
        type="file"
        hidden
        disabled={!isEdit}
        onChange={handleAadharSelect}
      />
    </label>
  )}
</div>
        {isWC && (
          <div className="rp-personalinfo-compliance-item">
            <label className="rp-personalinfo-label">Aadhar Back</label>

            {compliance.aadharBackURL ? (
              <div className="rp-personalinfo-file-card">
                <img
                  alt=""
                  src={
                    aadharBack instanceof File
                      ? URL.createObjectURL(aadharBack)
                      : compliance.aadharBackURL
                  }
                  className="rp-personalinfo-thumb"
                />
                <div className="rp-personalinfo-file-actions">
<button
  className="rp-personalinfo-view-btn"
  disabled={!compliance.aadharBackURL && !(aadharBack instanceof File)}
  onClick={() =>
    setPreviewImage(getFilePreview(aadharBack, compliance.aadharBackURL))
  }
>
  View
</button>

                  {isEdit && (
                    <label className="rp-personalinfo-change-btn">
                      Edit
                        <input
                        type="file"
                        hidden
                        onChange={(e) => {
                          if (e.target.files?.[0]) {
                            setAadharBack(e.target.files[0]);
                            setCompliance((prev) => ({
                              ...prev,
                              aadharBackURL: URL.createObjectURL(e.target.files[0]),
                            }));
                          }
                        }}
                      />
                    </label>
                  )}
                </div>
              </div>
            ) : (
              <span>No Back Side Uploaded</span>
            )}
          </div>
        )}

        {/* PAN */}
        <div className="rp-personalinfo-compliance-item">
          <label className="rp-personalinfo-label">Pan</label>

          {compliance.panURL || pan ? (
            <div className="rp-personalinfo-file-card">
            {pan instanceof File ? (
              <img
                src={URL.createObjectURL(pan)}
                className="rp-personalinfo-thumb"
                alt=""
              />
            ) : compliance.panURL ? (
              <img
                src={compliance.panURL}
                className="rp-personalinfo-thumb"
                alt=""
              />
            ) : (
              <span>No file selected</span>
            )}
              <div className="rp-personalinfo-file-actions">
<button
  className="rp-personalinfo-view-btn"
  disabled={!compliance.panURL && !(pan instanceof File)}
  onClick={() =>
    setPreviewImage(getFilePreview(pan, compliance.panURL))
  }
>
  View
</button>
                {isEdit && (
                  <label className="rp-personalinfo-change-btn">
                    Edit
                    <input type="file" hidden onChange={handlePanSelect} />
                  </label>
                )}
              </div>
            </div>
          ) : (
            <label className="rp-personalinfo-upload-card">
              <div className="rp-personalinfo-plus">+</div>
              <span>Upload Pan</span>
              <input type="file" hidden disabled={!isEdit} onChange={handlePanSelect} />
            </label>
          )}
        </div>

        <div className="rp-personalinfo-compliance-item">
          <label className="rp-personalinfo-label">Partner Photo</label>

          {compliance.partnerPhoto || photo ? (
            <div className="rp-personalinfo-file-card">
            {photo instanceof File ? (
              <img
                src={URL.createObjectURL(photo)}
                className="rp-personalinfo-thumb"
                alt=""
              />
            ) : compliance.partnerPhoto ? (
              <img
                src={compliance.partnerPhoto}
                className="rp-personalinfo-thumb"
                alt=""
              />
            ) : (
              <span>No file selected</span>
            )}

              <div className="rp-personalinfo-file-actions">
     <button
  className="rp-personalinfo-view-btn"
  disabled={!compliance.partnerPhoto && !(photo instanceof File)}
  onClick={() =>
    setPreviewImage(getFilePreview(photo, compliance.partnerPhoto))
  }
>
  View
</button>
                {isEdit && (
                  <label className="rp-personalinfo-change-btn">
                    Edit
                    <input type="file" hidden onChange={handlePhotoSelect} />
                  </label>
                )}
              </div>
            </div>
          ) : (
            <label className="rp-personalinfo-upload-card">
              <div className="rp-personalinfo-plus">+</div>
              <span>Upload Partner Phot</span>
              <input type="file" hidden disabled={!isEdit} onChange={handlePhotoSelect} />
            </label>
          )}
        </div>
        </div>
      {isEdit && (
        <div className="rp-personalinfo-actions">
          <button
            onClick={handleUpdate}
            className="rp-personalinfo-save-btn"
            disabled={isSaving} // ✅ disable during saving
          >
            {isSaving ? "Saving..." : "Save Changes"} {/* optional: show saving text */}
          </button>
        </div>
      )}
      </div>
{previewImage && (
  <div className="rp-image-preview-overlay">
    <div className="rp-image-preview-modal">
      <button
        className="rp-image-preview-close"
        onClick={() => setPreviewImage(null)}
      >
        ✕
      </button>
      <img src={previewImage} alt="Preview" />
    </div>
  </div>
)}
    </div>
    
  );
};

export default PersonalInfo;
